import React, {Component} from 'react';
import './Login.css';
import {Redirect, Link} from 'react-router-dom';

export default class Login extends Component {
    state = {
        redirectBool: false,
        emailString: '',
        passwordString: '',
        visibilityBool: true,
        toggleButtonString: 'show',

    };

    emailChange = (e) => {
        this.setState({emailString: e.target.value});
    };

    passwordChange = (e) => {
        this.setState({passwordString: e.target.value});
    };

    loginActivity = () => {
        fetch(`https://iotjokebase.herokuapp.com/loginuser?email=${this.state.emailString}&password=${this.state.passwordString}`, {method: 'GET'}).then(res => {
            res.json().then(resp => {
                if (resp.existBool) {
                    // if(resp.password === this.state.passwordString){
                    localStorage.setItem('uuid', resp.uuid);
                    localStorage.setItem('myName',resp.myname);
                    this.setState({redirectBool: true});
                    // } else{
                    //     alert('Wrong Credentials');
                    // }
                } else {
                    alert('Wrong Credentials');
                }
            }).catch(err => {
                console.log('JSON Error');
            });
        }).catch(err => {
            console.log('Error Fetching');
        });
    };

    redirectHome = () => {
        if (this.state.redirectBool && localStorage.getItem('uuid')!==null && localStorage.getItem('uuid')!=='undefined') {
            return (<Redirect to='/home'/>);
        }
    };

    toggleVisibility = () => {
        if (document.getElementById('checkToggle').checked) {
            document.getElementById('inputPassword').type = 'text';
        } else {
            document.getElementById('inputPassword').type = 'password';
        }
    };

    componentDidMount() {
        document.title = 'Login';
        if (localStorage.getItem('uuid') !== 'undefined') {
            this.setState({redirectBool: true});
        }
    }


    render() {
        return (
            <div>
                {this.redirectHome()}
            <div className='row'>
                <div className='col-md-4'></div>
                <div className='col-md-4'>
                    <h2>Please Sign in</h2>
            <form className="form-signin">

                <div className="form-label-group">
                    <label htmlFor="inputEmail"></label>

                    <input type="email" id="inputEmail" className="form-control" onChange={this.emailChange} placeholder="Email address" required
                           autoFocus/>
                </div>

                <div className="form-label-group">
                    <label htmlFor="inputPassword"></label>
                    <input type="password" id="inputPassword" onChange={this.passwordChange} className="form-control" placeholder="Password" required/>

                </div>
            </form>
                    <div>
                    <button style={{'padding': '8px 8px','marginBottom':'20px','marginTop':'20px'}}  className="btn btn-lg btn-outline-primary" onClick={this.loginActivity}>Sign in   <span><i className="fas fa-sign-in-alt"></i></span></button>
                    </div>
                    <div>
                    <Link style={{'padding': '6px 6px'}} to='/signup' className='btn btn-lg btn-outline-primary'>Register <span><i className="far fa-registered"></i></span></Link>
                    </div>
                    </div>
            </div>
                <div className='col-md-4'></div>

            </div>
        // /*{/*<div id='loginForm'>*/}
// {/*<label htmlFor="emailIn">Email</label>*/}
// {/*<input id='emailIn' type='email' onChange={this.emailChange}/>*/}
// {/*<label htmlFor="passId">Password</label>*/}
// {/*<input id='passId' type='password' onChange={this.passwordChange}/>*/}
// {/*<button id='showpass' onClick={this.toggleVisibility}>{this.state.toggleButtonString}</button>*/}
// {/*<button id='loginBut' onClick={this.loginActivity}>Login</button>*/}
// {/*<Link to='/signup'>SignUp</Link>*/}
// {/*</div>*/}*/
        );
    }
}
